export default "__VITE_ASSET__N$IYM0ko__"